/* eslint-disable */

import "../../common/css/new_public.css";
import "./new-list.less";
import myContent from "./new-list";
import VueResource from 'vue-resource';

Vue.use(VueResource);
(function () {
  new Vue({
    el: '#app',
    components: { 
      myContent: myContent
    }
  })
}())